export const YES = 'ano';
export const NO = 'ne';

export const YesNoOptions = [
	{
		value: YES,
		name: 'Ano',
	},
	{
		value: NO,
		name: 'Ne',
	},
];
